module.exports = __webpack_public_path__ + "static/media/mastercard.0e86d478.svg";